import React           from 'react'
import PropTypes       from 'prop-types';

import Translations         from '../../../utils/Translations';
import VXButton             from '../../SimpleElements/VXButton/VXButton';
import EnumVXButton         from "../../SimpleElements/VXButton/EnumVXButton";
import {VXButtonLineConfig} from "../../SimpleElements/VXButton/VXButtonConfig";
import Flux                 from '../../../flux/Flux';
import ProfileOverviewVideos, { GridTypes } from '../../Profile/ProfileOverviewVideos';

const LatestContentRecommendations = (props) => {

    const {
        actorId,
        actorName,
        count,
        isVideoContent,
        navigateTo,
        routes
    } = props;

    const titleKey = isVideoContent ? 'actor_profile.overview_latest-videos' : 'actor_profile.overview_latest-photos';
    const lineKey  = isVideoContent ? 'actor_profile.overview_all-content-button.videos' : 'actor_profile.overview_all-content-button.photos';

    const handleOnClick = (e) => {
        const path     = isVideoContent ? routes?.videos?.path : routes?.photos?.path;
        navigateTo(path, e);
    }

    const btnConfig = {
		line1:          [new VXButtonLineConfig(Translations.get(lineKey))],
        color:          EnumVXButton.COLORS.TRANSPARENT,
        iconPosition:   EnumVXButton.ICON_POSITION.LEFT,
        icon:           '-icon-double-arrow-right-line',
        preset:         EnumVXButton.PRESET.DEFAULT,
        border:         EnumVXButton.BORDER.OUTLINE,
        onMouseDown:    e => handleOnClick(e),
        staticMode:     true,
	};

    return (
        <>
            <section className="media-panel container-block -margin-bottom-lg">
                <div className="context-box--actor-profile content-box--flex-space-between">
                    <h3
                        className="context-box__title"
                        dangerouslySetInnerHTML={{ __html: Translations.get(titleKey) }}
                    />
                   {(count > 4) && <VXButton {...btnConfig} />}
                </div>
                <ProfileOverviewVideos
                    actorId          = {actorId}
                    actorName        = {actorName}
                    headlineType     = {Flux.Constants.Headlines.h4}
                    lazyImageLoading = {true}
                    navigateTo       = {navigateTo}
                    type             = {GridTypes.NEWEST}
                />

            </section>
        </>
    )
}

LatestContentRecommendations.propTypes = {
    actorId:               PropTypes.number.isRequired,
    actorName:             PropTypes.string.isRequired,
    count:                 PropTypes.number.isRequired,
    isVideoContent:        PropTypes.bool,
    routes:                PropTypes.object.isRequired
}

export default LatestContentRecommendations
